import { Injectable } from '@angular/core';
import { CobrancaDash } from '../models/cobranca-dash';
import { BehaviorSubject } from 'rxjs';
import { SaleDash } from '../models/sale-dash';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DashboardStoreService {
  private _cobranca = new BehaviorSubject<CobrancaDash>({
    recebidos: [],
    recebidosCC: [],
    recebidosCD: [],
    recebidosD: [],
    remarcados: 0,
  });

  private _sale = new BehaviorSubject<SaleDash>({
    totalOfSales: 0,
    totalOfBudgets: 0,
    conversionRate: 0,
    totalBilled: 0,
    averageValuePerContract: 0,
    averageValuePerLife: 0,
    plans: [],
    topSellers: [],
  });

  private _fromDate: Date = moment().clone().startOf('month').toDate();
  private _toDate: Date = moment().clone().endOf('month').toDate();

  constructor() {}

  private get cobranca(): CobrancaDash {
    return this._cobranca.getValue();
  }

  private set cobranca(val: CobrancaDash) {
    this._cobranca.next(val);
  }

  addCobranca(cobranca: CobrancaDash) {
    this.cobranca = cobranca;
  }

  private get sale(): SaleDash {
    return this._sale.getValue();
  }

  private set sale(val: SaleDash) {
    this._sale.next(val);
  }

  addSale(sale: SaleDash) {
    this.sale = sale;
  }

  get fromDate() {
    return this._fromDate;
  }

  set fromDate(val: Date) {
    this._fromDate = val;
  }

  get toDate() {
    return this._toDate;
  }

  set toDate(val: Date) {
    this._toDate = val;
  }

  // Expose the observable$ part of the _cobranca subject (read only stream)
  readonly cobranca$ = this._cobranca.asObservable();

  // Expose the observable$ part of the _sale subject (read only stream)
  readonly sale$ = this._sale.asObservable();
}
